import { showErrorSnackbar } from 'components/shared/Snackbar';
import { useQuery } from 'react-query';
import { getFlexHistoryValues } from 'RestAPIs/flex-history';

const useGetFlexHistoryValues = (
  startDate: string,
  endDate: string,
  brIds?: number[] | null,
  clusterId?: number | null,
  poolId?: number | null,
  employeeId?: number | null,
  requestReason?: string | null,
  functionId?: number | null,
  agencyId?: number[] | null,
  page?: number,
  pageSize?: number
) =>
  useQuery({
    queryKey: ['flexHistory', page, pageSize], // Include pagination in query key
    queryFn: async () => {
      try {
        const response = await getFlexHistoryValues(
          startDate,
          endDate,
          brIds,
          clusterId,
          poolId,
          employeeId,
          requestReason,
          functionId,
          agencyId,
          page,
          pageSize
        );

        const totalItems = response.headers['content-range']?.split('/')[1]; // Extract total items from Content-Range

        return {
          data: response.data,
          totalItems: parseInt(totalItems, 10) // Return total items with data
        };
      } catch (error) {
        showErrorSnackbar();
      }
    },
    onError: () => {
      showErrorSnackbar();
    },
    keepPreviousData: true,
    enabled: false
  });

export default useGetFlexHistoryValues;
